import { render, staticRenderFns } from "./agendamentos-view.vue?vue&type=template&id=6285fdbc"
import script from "./agendamentos-view.vue?vue&type=script&lang=js"
export * from "./agendamentos-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports